module.exports = new __parcel__URL__("background-dark.41c2b84f.png").toString();